import * as tslib_1 from "tslib";
import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import strings from 'owa-strings/owa-common-strings';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { observer } from 'mobx-react';
import { showUserVoiceSuggestionDialog } from 'owa-uservoice';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { isWorkloadSupported } from 'owa-workloads';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { loadMiniMavenHelpWidget, sendMiniMavenDataPoint, destroyWidgetOnPaneDismiss, getAlchemySolution, sendAlchemyDataPoint, } from 'owa-help-charm';
var styles = require('./HeaderPane.scss');
// TODO: Task 659 -- Provide context-sensitive help divs
var Helpdiv = 'https://go.microsoft.com/fwlink/?linkid=853225';
var Privacydiv = 'https://go.microsoft.com/fwlink/?linkId=521839';
var Termsdiv = 'https://www.microsoft.com/en-us/servicesagreement';
var isMiniMavenWidgetEnabled = isMailFeatureEnabled('help-miniMavenWidget');
var HelpPane = /** @class */ (function (_super) {
    tslib_1.__extends(HelpPane, _super);
    function HelpPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openHelpTab = function () {
            window.open(Helpdiv, '_blank');
        };
        _this.openPrivacyTab = function () {
            window.open(Privacydiv, '_blank');
        };
        _this.openTermsTab = function () {
            window.open(Termsdiv, '_blank');
        };
        _this.launchInAppFeedback = function () {
            showUserVoiceSuggestionDialog({
                feedbackType: 0 /* Feedback */,
            });
        };
        _this.getAlchemyClientContext = function (userConfig) {
            var sessionStartTime = new Date();
            sessionStartTime.setTime(window.performance.timing.fetchStart);
            var clientContext = {
                Country: userConfig.UserOptions.TimeZone,
                Platform: window.navigator.platform,
                BrowserLanguage: window.navigator.language,
                MbxCulture: userConfig.SessionSettings.UserCulture,
                OwaLayout: window.bootstrapOptions.app,
                OwaUtcStartTime: String(sessionStartTime),
                Ring: window.bootstrapDiagnostics.dring,
                Forest: window.bootstrapDiagnostics.fost,
            };
            return JSON.stringify(clientContext);
        };
        return _this;
    }
    HelpPane.prototype.getAlchemySolution = function (hostingDivElement) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userConfig, clientContext, alchemyBucketId, alchemyId, alchemyResponse;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!hostingDivElement) return [3 /*break*/, 2];
                        userConfig = getUserConfiguration();
                        clientContext = this.getAlchemyClientContext(userConfig);
                        alchemyBucketId = 'EmptyBucket';
                        alchemyId = 'EmptyId';
                        return [4 /*yield*/, getAlchemySolution({
                                UserId: '',
                                ClientContext: clientContext,
                                Locale: userConfig.SessionSettings.UserCulture,
                                Text: '',
                                ContextualData: {},
                            })];
                    case 1:
                        alchemyResponse = _a.sent();
                        if (alchemyResponse && alchemyResponse.AlchemySolution) {
                            if (alchemyResponse.AlchemySolution.AlchemyId) {
                                alchemyId = alchemyResponse.AlchemySolution.AlchemyId;
                            }
                            if (alchemyResponse.AlchemySolution.AlchemyBucketId) {
                                alchemyBucketId = alchemyResponse.AlchemySolution.AlchemyBucketId;
                            }
                            if (alchemyResponse.AlchemySolution.CustomerDetails) {
                                hostingDivElement.innerHTML += alchemyResponse.AlchemySolution.CustomerDetails;
                                hostingDivElement.style.display = 'block';
                            }
                        }
                        sendAlchemyDataPoint({
                            alchemyId: alchemyId,
                            clientContext: clientContext,
                            locale: userConfig.SessionSettings.UserCulture,
                            alchemyBucketId: alchemyBucketId,
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    HelpPane.prototype.componentWillUnmount = function () {
        if (isMiniMavenWidgetEnabled) {
            destroyWidgetOnPaneDismiss();
        }
    };
    HelpPane.prototype.render = function () {
        var _this = this;
        var isAlchemySolutionEnabled = isMailFeatureEnabled('help-proactiveMessaging');
        if (isMiniMavenWidgetEnabled) {
            sendMiniMavenDataPoint({
                sessionId: '',
                eventId: 'HelpPaneRendered',
                eventData: 'Owa Mail',
                loadTime: '',
                isDeeplinkScenario: '',
            });
        }
        return (React.createElement(HeaderFlexPane, { title: function () { return strings.helpCharm_ariaLabel; }, content: React.createElement("div", { className: styles.helpPaneDiv },
                isAlchemySolutionEnabled && (React.createElement("div", { className: styles.alchemyHostingDiv, ref: function (ref) { return _this.getAlchemySolution(ref); } },
                    React.createElement("div", { className: styles.alchemyHeaderDiv },
                        React.createElement(Icon, { className: styles.titleIcon, iconName: 'Info' }),
                        React.createElement("p", { className: styles.alchemyHeader }, strings.proactiveMessageHeader)))),
                isMiniMavenWidgetEnabled && (React.createElement("div", { className: styles.miniMavenWidgetHostingDiv },
                    React.createElement("div", { ref: function (ref) { return loadMiniMavenHelpWidget(ref, _this.props.onDismiss); } },
                        React.createElement(Spinner, { className: styles.miniMavenWidgetLoading })))),
                React.createElement("div", { className: styles.actionsDiv },
                    React.createElement("ul", { className: styles.actions },
                        React.createElement("li", null,
                            React.createElement(CommandButton, { onClick: this.launchInAppFeedback, text: strings.feedbackLink, className: styles.action })),
                        !isMiniMavenWidgetEnabled && (React.createElement("li", null,
                            React.createElement(CommandButton, { onClick: this.openHelpTab, text: strings.helpLink, className: styles.action }))),
                        React.createElement("li", null,
                            React.createElement(CommandButton, { onClick: this.openPrivacyTab, text: strings.privacyLink, className: styles.action })),
                        React.createElement("li", null,
                            React.createElement(CommandButton, { onClick: this.openTermsTab, text: strings.termsLink, className: styles.action })),
                        isWorkloadSupported(2 /* Calendar */) && (React.createElement("li", null,
                            React.createElement(CommandButton, { href: "https://www.microsoft.com/concern/calendarabuse", text: strings.reportCalendarAbuseLink, className: styles.action })))))), onDismiss: this.props.onDismiss }));
    };
    HelpPane = tslib_1.__decorate([
        observer
    ], HelpPane);
    return HelpPane;
}(React.Component));
export default HelpPane;
//# sourceMappingURL=HelpPane.js.map